// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"547791d3","450":"678575d1","453":"4f79fb11","455":"6bc87478","977":"be5a7b02"}[chunkId] + ".chunk.js";
};